import { FontWeight } from '@billy/design-system'
import styled from '@emotion/styled'

import { Themable } from '../../../../../../types/themable'

export const AddonsListWrapper = styled.div`
  margin: 12px;
`

export const HeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const LineSeparator = styled.div<Themable>`
  height: 1px;
  margin: 16px 0;
  border-bottom: ${({ theme }) => `1px solid ${theme.colors.newGray2}`};
`

export const Title = styled.p<Themable>`
  margin: auto 0;
  color: ${({ theme }) => theme.colors.newGrey1};
  font-size: 20px;
  line-height: 25px;
`

export const AddonContainer = styled.div`
  display: flex;
  justify-content: space-between;
`

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`

export const CenterColumn = styled(Column)`
  flex: 1;
  margin: 0 20px;
`

export const Name = styled.p<Themable>`
  color: ${({ theme }) => theme.ds.colors.base.textSecondary};
  font-size: 14px;
  font-weight: ${FontWeight.Medium};
  line-height: 20px;
`

export const AvailableText = styled.p<Themable>`
  color: ${({ theme }) => theme.ds.colors.base.textSecondary};
  font-size: 14px;
  line-height: 20px;
`

export const PriceInfoText = styled.p<Themable>`
  color: ${({ theme }) => theme.colors.grayA};
  font-size: 14px;
  line-height: 20px;
  text-align: right;
`
